module.exports = __webpack_public_path__ + "img/hovertip.52df5125.svg";